export const WIDTH = 'width';
export const HEIGHT = 'height';
export const X = 'x';
export const Y = 'y';
export const FULL_CIRCLE_ANGLE = 360;
export const TRANSPARENT = 'transparent';
export const START = 'start';
export const END = 'end';
export const CENTER = 'center';
export const NEW_LINE_CHAR = '\n';
export const SPACE = ' ';
export const EMPTY = '';
export const PX = 'px';
export const WRAP = 'wrap';
export const NO_WRAP = 'no-wrap';
/**
 * @deprecated Use `MarkerType` instead.
 */
export const Markers = {
    none: 'none',
    arrowStart: 'ArrowStart',
    filledCircle: 'FilledCircle',
    arrowEnd: 'ArrowEnd'
};
export var MarkerType;
(function (MarkerType) {
    MarkerType["None"] = "none";
    MarkerType["ArrowStart"] = "ArrowStart";
    MarkerType["FilledCircle"] = "FilledCircle";
    MarkerType["ArrowEnd"] = "ArrowEnd";
})(MarkerType || (MarkerType = {}));
;
export const DEG_TO_RAD = Math.PI / 180;
export const EPSILON = 1e-06;
export const CHANGE = 'change';
export const Cursors = {
    arrow: 'default',
    grip: 'pointer',
    cross: 'pointer',
    add: 'pointer',
    move: 'move',
    select: 'pointer',
    south: 's-resize',
    east: 'e-resize',
    west: 'w-resize',
    north: 'n-resize',
    rowresize: 'row-resize',
    colresize: 'col-resize'
};
export const HIT_TEST_DISTANCE = 10, AUTO = 'Auto', TOP = 'Top', RIGHT = 'Right', LEFT = 'Left', BOTTOM = 'Bottom', DEFAULT_SNAP_SIZE = 10, DEFAULT_SNAP_ANGLE = 10, DRAG_START = 'dragStart', DRAG = 'drag', DRAG_END = 'dragEnd', ITEMROTATE = 'itemRotate', ITEMBOUNDSCHANGE = 'itemBoundsChange', MIN_SNAP_SIZE = 5, MIN_SNAP_ANGLE = 5, MOUSE_ENTER = 'mouseEnter', MOUSE_LEAVE = 'mouseLeave', ZOOM_START = 'zoomStart', ZOOM_END = 'zoomEnd', TOOLTIP_SHOW = 'tooltipShow', TOOLTIP_HIDE = 'tooltipHide', SCROLL_MIN = -20000, SCROLL_MAX = 20000, FRICTION = 0.90, FRICTION_MOBILE = 0.93, VELOCITY_MULTIPLIER = 5, PAN = 'pan', ROTATED = 'rotated', SOURCE = 'source', TARGET = 'target', HANDLE_NAMES = {
    '-1': SOURCE,
    '1': TARGET
};
export const ConnectionEditing = 'Connection Editing';
export const ConnectionDragging = 'Connection Dragging';
export const INLINE = 'inline';
export const INLINE_PADDING = { left: 4, right: 4, top: 2, bottom: 2 };
export const NS = '.kendoDiagram', CASCADING = 'cascading', POLYLINE = 'polyline', CLICK = 'click', ERROR = 'error', MAXINT = 9007199254740992, SELECT = 'select', NONE = 'none', DEFAULT_CANVAS_WIDTH = 600, DEFAULT_CANVAS_HEIGHT = 600, DEFAULT_SHAPE_TYPE = 'rectangle', DEFAULT_SHAPE_WIDTH = 100, DEFAULT_SHAPE_HEIGHT = 100, DEFAULT_SHAPE_MINWIDTH = 20, DEFAULT_SHAPE_MINHEIGHT = 20, DEFAULT_SHAPE_POSITION = 0, DEFAULT_CONNECTION_BACKGROUND = 'Yellow', MAX_VALUE = Number.MAX_VALUE, MIN_VALUE = -Number.MAX_VALUE, ABSOLUTE = 'absolute', TRANSFORMED = 'transformed', MOUSEWHEEL_NS = 'DOMMouseScroll' + NS + ' mousewheel' + NS, MOBILE_ZOOM_RATE = 0.05, MOBILE_PAN_DISTANCE = 5, CONNECTION_POINTS_EDITING_SNAP = 6, CONNECTION_CONTENT_OFFSET = 5;
export const FOCUS_CLASS = 'k-focus';
export const ARIA_ACTIVEDESCENDANT = 'aria-activedescendant';
export const TABINDEX = 'tabindex';
// DOM Events
export const KEYDOWN = 'keydown';
export const MOUSEDOWN = 'mousedown';
export const TOUCHSTART = 'touchstart';
export const POINTERDOWN = 'pointerdown';
export const FOCUS = 'focus';
export const BLUR = 'blur';
// Keyboard Keys
export const ARROW_RIGHT = 'ArrowRight';
export const ARROW_LEFT = 'ArrowLeft';
export const ARROW_UP = 'ArrowUp';
export const ARROW_DOWN = 'ArrowDown';
export const KEY_HOME = 'Home';
export const KEY_END = 'End';
// Element Types
export const SHAPE = 'Shape';
export const CONNECTION = 'Connection';
// DOM Attributes
export const CLASS_NAME = 'className';
